import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filtered } from '../redux/books/actions';

const FilterBtns = () => {
  const dispatch = useDispatch();
  const { categoryValue } = useSelector((state) => state.books);

  return (
    <div className="flex items-center space-x-4">
      <button
        className={`filter-btn ${
          categoryValue === 'all' ? 'active-filter' : ''
        }`}
        id="lws-filterAll"
        onClick={() => dispatch(filtered('all'))}
      >
        All
      </button>
      <button
        className={`filter-btn ${
          categoryValue === 'featured' ? 'active-filter' : ''
        }`}
        id="lws-filterFeatured"
        onClick={() => dispatch(filtered('featured'))}
      >
        Featured
      </button>
    </div>
  );
};

export default FilterBtns;
